import * as React from 'react'
import {Box, Container, Grid, GridItem} from "@chakra-ui/react";
import CyrekDigital from './images/cyrekdigital.svg'
import SinglePrevNext from "./singlePrevNext";

export default function PrevNext(props){

    const other = (props.other) ? props.other : null
    const lang = props.lang ?? 'PL'

    const translation = {
        prevText : {
            PL : 'Poprzedni wpis',
            EN : 'Previous post',
        },
        nextText : {
            PL : 'Następny wpis',
            EN : 'Next post',
        }
    }


    return(
        <>
            {other &&
                <Container mx={{lg:'60px',xxl:'auto'}} maxW={{base:'100%',lg:'calc(100% - 120px)', xxl: 'container.xxl'}} px={{base:'20px', lg: '0'}}>
                    <Grid templateColumns={{base: '1fr', lg: '1fr 1fr 1fr'}} gap={{base: '20px',lg: '130px'}} mt={{base: '20px', lg: '80px'}}
                          mb={{base: '20px', lg: '80px'}}>
                        <GridItem display={{base:'none', lg: 'flex'}} alignItems={'flex-end'} flexDirection={'column'}>
                        {other.previous &&
                            <SinglePrevNext node={other.previous} dir={'previous'} text={translation.prevText[lang]}/>
                        }
                        </GridItem>
                        <GridItem display={{base: 'none', lg: 'block'}}>
                            <Box as={CyrekDigital} mt={'40px'} w={'100%'}/>
                        </GridItem>
                        <GridItem display={'flex'} alignItems={'flex-start'} flexDirection={'column'}>
                        {other.next &&
                            <SinglePrevNext node={other.next} dir={'next'} text={translation.nextText[lang]}/>
                        }
                        </GridItem>
                    </Grid>
                </Container>
            }
        </>
    )
}